import { handleApiCall } from '../../utils/api.mts'
import { setupSdk } from '../../utils/sdk.mts'

import type { CResult } from '../../types.mts'
import type { SetupSdkOptions } from '../../utils/sdk.mts'
import type { RepositoryResult } from '@socketsecurity/sdk'

export type FetchViewRepoOptions = {
  sdkOpts?: SetupSdkOptions | undefined
}

export async function fetchViewRepo(
  orgSlug: string,
  repoName: string,
  options?: FetchViewRepoOptions | undefined,
): Promise<CResult<RepositoryResult['data']>> {
  const { sdkOpts } = { __proto__: null, ...options } as FetchViewRepoOptions

  const sockSdkCResult = await setupSdk(sdkOpts)
  if (!sockSdkCResult.ok) {
    return sockSdkCResult
  }
  const sockSdk = sockSdkCResult.data

  return await handleApiCall(sockSdk.getRepository(orgSlug, repoName), {
    description: 'repository data',
  })
}
